import angular from 'angular';

export default function TapOutside($document, isMobile){
    "ngInject";
    return {
        restrict: 'A',
        scope: {
            tapOutside: '&'
        },
        link: (scope, el, attr) => {
            $document.on('click', (e) => {
                if (el !== e.target && !el[0].contains(e.target) && !e.target.hasAttribute('menu-trigger') && !el[0].classList.contains(attr.hiddenClass) && isMobile){
                    scope.$apply(() => {
                        scope.$eval(scope.tapOutside);
                    });
                };
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/directives/tap-outside.directive.js